import React, { createContext, PropsWithChildren, useContext, useMemo, useState, ReactElement } from 'react';
// eslint-disable-next-line import/no-unresolved
import { DealMarketStatus } from '@creditsights/cs-web';
import { DealSecurityType } from '../../../models/CompanyDeal';
import { CompanyDealsContextType } from './CompanyDealsContext.types';

const CompanyDealsContext = createContext<CompanyDealsContextType | null>(null);

const CompanyDealsContextProvider = ({ children }: PropsWithChildren): ReactElement => {
  const [dealSecurityType, setDealSecurityType] = useState<DealSecurityType>(DealSecurityType.Bond);
  const [activeTab, setActiveTab] = useState<DealMarketStatus>(DealMarketStatus.InMarket);

  const value: CompanyDealsContextType = useMemo(
    () => ({
      dealSecurityType,
      setDealSecurityType,
      activeTab,
      setActiveTab,
    }),
    [dealSecurityType, setDealSecurityType, activeTab, setActiveTab]
  );

  return <CompanyDealsContext.Provider value={value}>{children}</CompanyDealsContext.Provider>;
};

const useCompanyDealsContext = (): CompanyDealsContextType => {
  const context = useContext(CompanyDealsContext);
  if (!context) {
    throw new Error('Hook must be used within the provider.');
  }

  return context;
};

export { CompanyDealsContextProvider, useCompanyDealsContext };
